import * as React from 'react';

export const MOBILE_BREAKPOINT = 768;

function getClientWindow(): Window | undefined {
  return typeof window === 'undefined' ? undefined : window;
}

export function useIsMobile() {
  // SSR-safe: always return false on server for consistent hydration
  const [isMobile, setIsMobile] = React.useState<boolean>(false);

  React.useEffect(() => {
    const clientWindow = getClientWindow();
    if (!clientWindow?.matchMedia) {
      return;
    }

    const mql = clientWindow.matchMedia(
      `(max-width: ${MOBILE_BREAKPOINT - 1}px)`,
    );

    const onChange = (e: MediaQueryListEvent | MediaQueryList) => {
      setIsMobile(e.matches);
    };

    // Initial sync on mount
    onChange(mql);

    // Safari < 14 compatibility: use addListener/removeListener as fallback
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
    } else if ('addListener' in mql) {
      (mql as { addListener: (cb: typeof onChange) => void }).addListener(
        onChange,
      );
    }

    return () => {
      if (mql.removeEventListener) {
        mql.removeEventListener('change', onChange);
      } else if ('removeListener' in mql) {
        (
          mql as { removeListener: (cb: typeof onChange) => void }
        ).removeListener(onChange);
      }
    };
  }, []);

  return isMobile;
}
